/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Level_HintInputs */

const en_us2_profile_level_hint = /** @type {(inputs: Profile_Level_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worked out from the answers above; it can't be chosen.`)
};

const pt_br2_profile_level_hint = /** @type {(inputs: Profile_Level_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculado pelas respostas acima, não dá para escolher.`)
};

const es_419_profile_level_hint = /** @type {(inputs: Profile_Level_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se calcula con las respuestas de arriba; no se puede elegir.`)
};

const pt_pt2_profile_level_hint = /** @type {(inputs: Profile_Level_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculado a partir das respostas acima, não pode ser escolhido.`)
};

const fr_fr2_profile_level_hint = /** @type {(inputs: Profile_Level_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déduit des réponses ci-dessus ; il ne se choisit pas.`)
};

const de_de2_profile_level_hint = /** @type {(inputs: Profile_Level_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus den Antworten oben berechnet; nicht wählbar.`)
};

const it_it2_profile_level_hint = /** @type {(inputs: Profile_Level_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolato dalle risposte sopra; non si può scegliere.`)
};

/**
* | output |
* | --- |
* | "Worked out from the answers above; it can't be chosen." |
*
* @param {Profile_Level_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_level_hint = /** @type {((inputs?: Profile_Level_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Level_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_level_hint(inputs)
	if (locale === "es-419") return es_419_profile_level_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_level_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_level_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_level_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_level_hint(inputs)
	return en_us2_profile_level_hint(inputs)
});
export { profile_level_hint as "profile.level_hint" }